// 用 import.meta.env.BASE_URL 自动适配开发/生产环境的资源路径
// 开发: BASE_URL = '/'  → demofile('mp3/foo.flac') = '/demofile/mp3/foo.flac'
// 生产: BASE_URL = '/ControlFoley_web_page/' → demofile('mp3/foo.flac') = '/ControlFoley_web_page/demofile/mp3/foo.flac'
export const demofile = (path: string): string =>
  `${import.meta.env.BASE_URL}demofile/${path}`;

/**
 * 与 `.mp4` 同目录的封面：`foo/bar.mp4` → `foo/bar.poster.jpg`（deploy / ffmpeg 生成）
 * `pathUndecoded` 为未编码的斜杠路径，每段会单独 encodeURIComponent。
 */
export function demofileSiblingPoster(pathUndecoded: string): string {
  const segments = pathUndecoded.split('/').filter(Boolean);
  if (segments.length === 0) return demofile('');
  const last = segments[segments.length - 1]!;
  const posterLast = last.replace(/\.mp4$/i, '.poster.jpg');
  const encoded = [...segments.slice(0, -1), posterLast].map((s) => encodeURIComponent(s)).join('/');
  return demofile(encoded);
}
